<template>
  <section class="results">
    <h6 class="ms-1 mb-5 mt-2 text-gray-700">Результаты поиска</h6>
    <div v-if="hasResults" class="rounded border bg-white info-panel custom-table">
      <div class="table-responsive">
        <table
          class="podft table table-striped table-hover table-row-dashed fs-8 table-row-gray-300 gy-3 mb-0 text-gray-800"
          style="white-space: nowrap !important;"
        >
          <thead>
            <tr class="fw-bold fs-8 text-gray-400">
              <th>Договора</th>
              <th>Продукт</th>
              <th>Страхователь</th>
              <th>Премия</th>
              <th>Срок действия</th>
              <th>Статус</th>
              <th>Создано</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in results" :key="key" class="align-middle">
              <td>{{ item.number ?? item.number }}</td>
              <td>{{ item.product?.title }}</td>
              <td>{{ item.client?.title }}</td>
              <td>{{ item.premium ? item.premium.toLocaleString('ru-RU') + ' тг.' : '' }}</td>
              <td>
                <span class="text-primary">{{ item.date_from }}</span> - <span class="text-danger">{{ item.date_to }}</span>
              </td>
              <td>{{ item.status?.title }}</td>
              <td>{{ item.date }}</td>
              <td class="text-end">
                <slot name="actions" :item="item" :index="key" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="d-flex justify-content-center align-items-center rounded border bg-white info-panel fs-6 text-gray-400 custom-table h-200px">
      Нет информации
    </div>
  </section>
</template>

<script>
export default {
  name: 'PolicySearchResultsTable',
  props: {
    results: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasResults() {
      return this.results.length > 0
    }
  }
}
</script>
